import * as types from "@/store/constants/types";
export default {
  [types.UPDATE_INS_COOKIE_BY_USER_ID](state: any, payLoad: any) {
    //字段做merge操作：
    const { userId, cookie } = payLoad;
    const findUser = state.cookieData.find((item: any) => {
      return item.userId.toString() === userId.toString();
    });
    if (findUser !== undefined) {
      const newCookie = {
        ...findUser.cookie,
        ...cookie
      };
      findUser.cookie = newCookie;
    } else {
      const newUser = {
        userId,
        cookie
      };
      state.cookieData.push(newUser);
    }
  }
};
